// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mvzF","fullView":"styles_fullView__qE-xv"};